module.exports = __webpack_public_path__ + "img/az.420100cc.png";